import { CUSTOMER_DISPLAY_EVENTS as events, CUSTOMER_DISPLAY_NAMESPACE } from '@washday/utilities';
/** Socket implementation is supplied by the platform, so native and web use the same protocol. */
export function createCustomerDisplayConnection(options) {
    const socket = options.socketFactory(`${options.baseUrl.replace(/\/$/, '')}${CUSTOMER_DISPLAY_NAMESPACE}`, {
        transports: ['websocket'], forceNew: true, auth: { token: options.token }
    });
    let authorized = false;
    let stopped = false;
    let heartbeat;
    let retry;
    const claim = () => {
        if (stopped)
            return;
        socket.emit(events.claim, {
            displayId: options.displayId, publisherKey: options.publisherKey,
            publisherInstanceId: options.publisherInstanceId,
            companyId: options.companyId, storeId: options.storeId
        }, (result) => {
            if (stopped)
                return;
            authorized = Boolean(result === null || result === void 0 ? void 0 : result.ok);
            options.onStatus(authorized ? 'connected' : (result === null || result === void 0 ? void 0 : result.error) === 'busy' ? 'busy' : (result === null || result === void 0 ? void 0 : result.error) === 'forbidden' ? 'forbidden' : 'disconnected');
            if (authorized)
                options.onRequest();
            else if ((result === null || result === void 0 ? void 0 : result.error) === 'busy' || (result === null || result === void 0 ? void 0 : result.error) === 'unavailable')
                retry = setTimeout(claim, 5000);
        });
    };
    socket.on('connect', () => {
        authorized = false;
        clearTimeout(retry);
        claim();
        clearInterval(heartbeat);
        heartbeat = setInterval(() => {
            if (authorized) {
                socket.emit(events.heartbeat);
                // Rehydrate viewers after an isolated Redis subscriber reconnect without a status change.
                options.onRequest();
            }
        }, 10000);
    });
    socket.on(events.request, () => { if (authorized)
        options.onRequest(); });
    socket.on('disconnect', () => { authorized = false; options.onStatus('disconnected'); clearInterval(heartbeat); });
    socket.on('connect_error', () => { authorized = false; options.onStatus('disconnected'); });
    socket.on(events.status, (message) => {
        const status = message;
        if ((status === null || status === void 0 ? void 0 : status.connected) === false) {
            authorized = false;
            options.onStatus(status.error === 'forbidden' ? 'forbidden' : status.error === 'busy' ? 'busy' : 'disconnected');
            clearTimeout(retry);
            if (!stopped && status.error !== 'forbidden')
                retry = setTimeout(claim, 5000);
        }
    });
    return {
        publish(snapshot) {
            if (authorized && !stopped)
                socket.emit(events.snapshot, snapshot);
            return authorized && !stopped;
        },
        dispose() {
            stopped = true;
            authorized = false;
            clearInterval(heartbeat);
            clearTimeout(retry);
            socket.emit(events.release);
            socket.disconnect();
        }
    };
}
